import { httpsCallable } from "firebase/functions";
import { functions } from "../../services/firebase";
const methods = {};
const call = async (name, payload) => {
  methods[name] ||= httpsCallable(functions, name, { timeout: 120000 });
  const response = await methods[name](payload);
  return response.data;
};
export const listStaffNotes = (childId) => call("listStaffNotes", { childId });
export const signStaffNotes = (payload) => call("signStaffNotes", payload);
export const mutateStaffNote = (payload) => call("mutateStaffNote", payload);
export const setStaffCaregiverType = (payload) =>
  call("setStaffCaregiverType", payload);
export const getStaffOriginal = (captureId) =>
  call("getStaffOriginal", { captureId });

export const listProfessionalDocumentation = (childId) => call("listProfessionalDocumentation", { childId });
